import { clientApi } from 'shared/api/clientApi'

import type {
  KyrgyzstanOwnerCountersResponse,
  KyrgyzstanOwnerModerationDraftsRequest,
  KyrgyzstanOwnerModerationDraftsResponse,
  KyrgyzstanOwnerOrderActionResponse,
  KyrgyzstanOwnerOrdersRequest,
  KyrgyzstanOwnerOrdersResponse,
  KyrgyzstanOwnerRealtyObjectsRequest,
  KyrgyzstanOwnerRealtyObjectsResponse,
  KyrgyzstanOwnerRejectOrderRequest,
} from './model'

const REJECT_ORDER_REASON_PLACEHOLDER = 'string'

export const KyrgyzstanWebviewOwnerApi = {
  getCounters(signal?: AbortSignal) {
    return clientApi.get<KyrgyzstanOwnerCountersResponse>(
      '/kyrgyzstan/webview-owner/counters',
      { signal },
    )
  },

  getRealtyObjects(
    params: KyrgyzstanOwnerRealtyObjectsRequest,
    signal?: AbortSignal,
  ) {
    return clientApi.get<KyrgyzstanOwnerRealtyObjectsResponse>(
      '/kyrgyzstan/webview-owner/realty-objects',
      {
        params,
        signal,
      },
    )
  },

  getModerationDrafts(
    params: KyrgyzstanOwnerModerationDraftsRequest,
    signal?: AbortSignal,
  ) {
    return clientApi.get<KyrgyzstanOwnerModerationDraftsResponse>(
      '/kyrgyzstan/webview-owner/realty-objects/draft/moderation',
      {
        params,
        signal,
      },
    )
  },

  getOrders(params: KyrgyzstanOwnerOrdersRequest, signal?: AbortSignal) {
    return clientApi.get<KyrgyzstanOwnerOrdersResponse>(
      '/kyrgyzstan/webview-owner/orders',
      {
        params,
        signal,
      },
    )
  },

  approveOrder(orderId: string) {
    return clientApi.post<KyrgyzstanOwnerOrderActionResponse>(
      `/kyrgyzstan/webview-owner/orders/${orderId}/approve`,
    )
  },

  rejectOrder(orderId: string, reason = REJECT_ORDER_REASON_PLACEHOLDER) {
    const payload: KyrgyzstanOwnerRejectOrderRequest = { reason }

    return clientApi.post<KyrgyzstanOwnerOrderActionResponse>(
      `/kyrgyzstan/webview-owner/orders/${orderId}/reject`,
      payload,
    )
  },
}
